/**
 * Contact form API — sends submission to backend, which emails info@insoliptechnologies.com
 */

import axios from 'axios';
import { API_BASE_URL } from '@/config/apiBase';

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

export async function submitContactForm(data: ContactFormData): Promise<void> {
  try {
    const response = await axios.post<{ message: string }>(
      `${API_BASE_URL.replace(/\/$/, '')}/contact`,
      data,
      { headers: { 'Content-Type': 'application/json' } }
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message || 'Failed to send message');
    }
  } catch (err: unknown) {
    if (axios.isAxiosError(err) && err.response?.data?.message) {
      throw new Error(err.response.data.message);
    }
    throw err;
  }
}
